/**
 *
 * @type {{HybridGeneralSpecific: {label: string, value: string}, SupplierSpecific: {label: string, value: string}, General: {label: string, value: string}}}
 */
export const EMISSION_FACTOR_DATATYPES = {
  General: {
    value: "general",
    label: "General",
  },
  SupplierSpecific: {
    value: "supplier_specific",
    label: "Supplier specific",
  },
  HybridGeneralSpecific: {
    value: "hybrid_general_specific",
    label: "Hybrid general/specific",
  },
};
